"use client";
import { useGlobalContext } from "../../../app/context/store";
import { useUpgradeModal } from "./upgrade-modal";
import { useGenerator } from "@/app/context/GeneratorContext";

export default function ResToggle({
  toggle,
  type,
  translations,
}: {
  toggle: any;
  type: string; // Typing the toggle prop as Tag
  translations: any;
}) {
  const { user } = useGlobalContext();
  const { state, setResolution, setGifAspectRatio } = useGenerator();
  const { UpgradeModal, setShowUpgradeModal } = useUpgradeModal(translations);

  // Check if the toggle is selected
  const handleToggleClick = (toggle: any) => {
    if (type === "image") {
      if (
        (user._id !== "none" && user.membership?.level === 1 ? false : true) &&
        (toggle.value === 4 ||
          toggle.value === 5 ||
          toggle.value === 6 ||
          toggle.value === 8 ||
          toggle.value === 9)
      ) {
        setShowUpgradeModal(true);
        // window.alert(locale.accessViaPremium); //change this to premium only feature
        return;
      } else {
        setResolution(toggle.value);
      }
    } else {
      setGifAspectRatio(toggle.string);
    }
  };

  let stringText = toggle.string;

  const buttonStyle = `mb-2 mr-2 rounded-full border-[0.5px] border-[#3C3C3C] px-3.5 py-[4px] text-sm font-medium text-white hover:bg-gray-900 hover:brightness-105 focus:outline-none focus:ring-0 focus:ring-gray-300 sm:px-5 sm:py-1.5 dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700`;

  return (
    <>
      <UpgradeModal />
      {type === "image" ? (
        <button
          type="button"
          onClick={() => handleToggleClick(toggle)}
          style={{
            backgroundColor: state.resolution === toggle.value ? "#0772DD" : "#343639",
          }}
          className={buttonStyle}
        >
          <div className={`flex flex-row ${stringText.includes("⟡") ? "ml-[-3px]" : ""}`}>
            {toggle.string}
          </div>
        </button>
      ) : (
        <button
          type="button"
          onClick={() => handleToggleClick(toggle)}
          style={{
            backgroundColor: state.gifAspectRatio === toggle.string ? "#0772DD" : "#343639",
          }}
          className={buttonStyle}
        >
          <div className={`flex flex-row ${stringText.includes("⟡") ? "ml-[-3px]" : ""}`}>
            {toggle.string}
          </div>
        </button>
      )}
    </>
  );
}
